import styled, { css } from 'styled-components';

import { hideScrollbars } from 'styles/utils/hideScrollbars';
import { variableFontRegular } from 'styles/theme/text';

export const GRIDS_WIDTH = '75%';

export const SUPER_COMPRESSED_DESKTOP_HEADER_HEIGHT = '96px';
export const SUPER_COMPRESSED_DESKTOP_HEADER_HEIGHT_NUMBER = 78;

export const TIMELINE_NAVIGATION_DESKTOP_HEIGHT = '55px';

export const SEARCH_FILTER_DESKTOP_SCROLLABLE_HEIGHT = '180px';

export const SearchTitle = styled.h1`
  ${variableFontRegular({ size: '9.5px', height: '12px' })};
  font-weight: 400;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    ${variableFontRegular({ size: '9.5px', height: '12px' })};
  }
`;

export const SearchBoxButton = styled.button<{ darkTheme?: boolean }>`
  ${variableFontRegular({ size: '11.5px', height: '11px' })};
  color: ${({ theme, darkTheme }) => (darkTheme ? theme.colors.white : theme.colors.black)};
  border: ${({ theme, darkTheme }) => (darkTheme ? theme.borders.white : theme.borders.black)};
  padding: 6px 4px 4px;
  margin: 0 8px 8px 0;

  &:active {
    border: ${({ theme, darkTheme }) => (darkTheme ? theme.borders.white : theme.borders.black)};
  }

  &:hover {
    text-decoration: underline;
  }
`;

export const SearchFiltersHoverAndSelectedStyle = css`
  text-decoration: underline !important;
  text-underline-offset: 2px;
`;

export const SearchFilterListOption = styled.a<{ $isSelected?: boolean }>`
  display: block;
  padding: 0 0 4px;
  word-break: break-word;
  cursor: pointer !important;
  ${({ $isSelected }) => $isSelected && SearchFiltersHoverAndSelectedStyle};

  &:hover {
    ${SearchFiltersHoverAndSelectedStyle};
  }
`;

export const SearchFilterDesktopTitle = styled.button<{
  isFilterOpen: boolean;
  hasFilterApplied: boolean;
}>`
  display: block;
  text-align: right;
  width: 100%;
  text-transform: capitalize;
  cursor: pointer;
  padding: 0 0 4px;
  ${({ isFilterOpen }) => isFilterOpen && SearchFiltersHoverAndSelectedStyle};
  ${({ hasFilterApplied }) => hasFilterApplied && SearchFiltersHoverAndSelectedStyle};

  &:hover {
    ${SearchFiltersHoverAndSelectedStyle};
  }
`;

export const SearchFilterDesktopCollapsible = styled.div<{
  scrollable?: boolean;
  isFilterOpen?: boolean;
  isCrawler?: boolean;
}>`
  ${({ isCrawler, isFilterOpen }) =>
    isCrawler
      ? css`
          display: ${isFilterOpen ? 'flex' : 'none'};
        `
      : css`
          display: flex;
        `}

  flex-direction: column;
  align-items: flex-end;
  padding-bottom: 32px;

  ${({ scrollable, theme }) =>
    scrollable &&
    css`
      overflow-y: scroll;
      max-height: ${SEARCH_FILTER_DESKTOP_SCROLLABLE_HEIGHT};
      border-bottom: 1px solid ${theme.navigation.borderColor};
      padding-bottom: 4px;
      margin-bottom: 32px;
      ${hideScrollbars};
    `}
`;

export const getModalGridTemplateColumnStyle = (columns: number) => {
  switch (columns) {
    case 3:
      return '3fr 1fr 16px';
    case 4:
      return '2.5fr 1.5fr 1fr 16px';
    default:
      return 'auto';
  }
};

export const SearchFilterPillStyle = css<{ $isSelected: boolean }>`
  ${variableFontRegular({ size: '11.5px', height: '11px' })};
  border: 1px solid ${({ theme }) => theme.navigation.borderColor};
  border-radius: 15px;
  color: ${({ theme }) => theme.navigation.textColor};
  cursor: pointer;
  margin: 0 8px 0 0;
  display: inline-block;
  padding: 6px 4px 4px;
  ${({ $isSelected }) =>
    $isSelected &&
    css`
      text-decoration: none;
      color: ${({ theme }) => theme.navigation.backgroundColor};
      background-color: ${({ theme }) => theme.navigation.textColor};
    `};

  &:hover {
    text-decoration: none;
    color: ${({ $isSelected, theme }) =>
      $isSelected ? theme.navigation.backgroundColor : theme.navigation.textColor};
  }
`;
